import React from "react";
import {MainLayout} from "../../layouts/MainLayout";
import useFetchEmployees from "../../hooks/useFetchEmployees";
import PendingRegistrations from "./pendingEmployees";
import ActiveEmployees from "./activeEmployees";
import {useTranslation} from "react-i18next";
import {pendingRegistrationStatuses} from "../../utils/constants";
import {useSelector} from "react-redux";
import {TopNotification} from "../../components";
import {selectEmployeesByStatuses} from "../../app/employee/selectors";

const DATA_ITEMS_PER_TABLE:number = 6

export const Employees = () => {
    useFetchEmployees()

    const {t} = useTranslation()

    const pendingRegistrations = useSelector(
        selectEmployeesByStatuses(
            pendingRegistrationStatuses
        )
    ).length

    return <MainLayout>
        {pendingRegistrations > 0 && <TopNotification
            type='warning'
            message={t('notification_pending_registrations')}
        />}
        <ActiveEmployees
            itemsPerPage={DATA_ITEMS_PER_TABLE}
        />
        <div style={{marginTop: '20px'}}></div>
        <PendingRegistrations
            itemsPerPage={DATA_ITEMS_PER_TABLE}
        />
    </MainLayout>
}

export default Employees;
